"use client";

import { useLanguage } from "@/i18n/LanguageContext";

interface CoralGablesHeroProps {
  h1?: string;
  subhead?: string;
  zips?: string[];
}

export default function CoralGablesHero({ h1, subhead, zips }: CoralGablesHeroProps) {
  const { t, currentLang } = useLanguage();
  return (
    <section className="relative w-full min-h-[80vh] overflow-hidden">
      <img
        src="https://storage.readdy-site.link/project_files/76915537-ee3f-4564-9a23-41bd98b5df27/5e15ac98-50a1-4b8b-a96b-dcfecd86868b_impact-windows-coral-gables.jpg?v=6817a32da525329c4982874fc1e85c90"
        alt={currentLang === "es" ? "Reparación de ventanas Coral Gables Miami" : "Window repair in Coral Gables Miami"}
        className="absolute inset-0 w-full h-full object-cover"
        onError={(e) => {
          (e.target as HTMLImageElement).style.backgroundColor = "#064e3b";
        }}
      />
      <div className="absolute inset-0" style={{ backgroundColor: "rgba(6,78,59,0.6)" }} />
      <div className="absolute bottom-16 left-8 md:left-16 z-10 max-w-3xl">
        <p className="text-[#fbbf24] uppercase tracking-[0.2em] text-sm font-bold mb-6">
          {currentLang === "es" ? "Reparación de Ventanas para Casas en Coral Gables" : "Window Repair for Coral Gables Homes"}
        </p>
        <h1 className="text-white text-5xl md:text-6xl font-serif font-bold mb-6 leading-tight">
          {h1 || t("coralGables.h1")}
        </h1>
        <p className="text-white/90 text-lg leading-relaxed mb-8">
          {subhead || t("coralGables.subhead")}
        </p>
        {zips && zips.length > 0 && (
          <p className="text-white/60 text-sm mb-4 tracking-wide uppercase font-semibold">
            {zips.join(" · ")}
          </p>
        )}
        <a
          href="tel:+17863774452"
          className="inline-flex items-center gap-2 bg-[#ea580c] text-white px-10 py-4 text-sm font-bold rounded-md hover:bg-[#c2410c] transition-colors whitespace-nowrap"
        >
          <i className="ri-phone-line" />
          {t("hood.callNow")}
        </a>
      </div>
    </section>
  );
}